export default __webpack_public_path__ + "static/media/purelove.0a98c15c.svg";